export default __webpack_public_path__ + "static/media/course.e4795a63.svg";